import withQuoteCTA from 'components/hoc/withQuoteCTA';
import { withProps, compose } from 'recompose';
import PageHeader from 'components/general/PageHeader/PageHeader';

const CountriesPageHeader = compose(
  withProps({
    title: 'Countries',
    section: {
      title: 'Countries',
    },
    actions: [{
      title: 'Compare countries',
      icon: 'pie-chart',
      to: {
        type: 'COUNTRIES_COMPARISON',
      },
      event: 'Clicked Compare Countries',
    }],
  }),
  withQuoteCTA(),
)(PageHeader);

export default CountriesPageHeader;
